module.exports = __webpack_public_path__ + "assets/img/dalarm.d018f120.svg";